import * as Sentry from '@sentry/nuxt';

const config = useRuntimeConfig();
const dsn = config.public.sentryDsn;

if (dsn) {
  Sentry.init({
    dsn,
    environment: config.public.sentryEnvironment,
    release: config.public.sentryRelease,
    tracesSampleRate: Number(config.public.sentryTracesSampleRate),
    traceLifecycle: 'static',
    tracePropagationTargets: [
      /^\/api(?:\/|$)/,
      new RegExp(`^${window.location.origin.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}/api(?:/|$)`),
      ...(typeof config.public.apiBase === 'string' && /^https?:\/\//.test(config.public.apiBase) ? [config.public.apiBase] : []),
    ],
    replaysSessionSampleRate: Number(config.public.sentryReplaysSessionSampleRate),
    replaysOnErrorSampleRate: 1,
    dataCollection: { userInfo: false, cookies: false, httpBodies: [] },
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
        maskAttributes: [],
        // rrweb always masks password inputs, independently of these options.
        networkDetailAllowUrls: [],
        networkCaptureBodies: false,
      }),
      Sentry.browserSessionIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
    ],
  });
}
